import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { IconButton, Tooltip } from "@mui/material";
import PropTypes from "prop-types";

const iconMap = {
  help: HelpOutlineIcon,
  info: InfoOutlinedIcon,
  warning: WarningAmberIcon,
  error: ErrorOutlineIcon,
};

const colorMap = {
  action: "action",
  primary: "primary",
  info: "info",
  warning: "warning",
  error: "error",
};

const HelpTooltip = ({
  title,
  placement = "top",
  size = "small",
  color = "action",
  interactive = false,
  maxWidth = 300,
  icon = "help",
  sx = {},
}) => {
  const IconComponent =
    typeof icon === "string" ? iconMap[icon] || HelpOutlineIcon : icon;
  const iconColor = colorMap[color] || "action";

  return (
    <Tooltip
      title={title}
      arrow
      placement={placement}
      enterDelay={200}
      leaveDelay={interactive ? 200 : 0}
      disableInteractive={!interactive}
      slotProps={{
        tooltip: {
          sx: {
            maxWidth: maxWidth,
            fontSize: "0.7rem",
            lineHeight: 1.5,
          },
        },
      }}
    >
      <IconButton
        size={size}
        sx={{
          p: size === "small" ? 0.5 : 1,
          ml: 0.5,
          ...sx,
        }}
      >
        <IconComponent fontSize={size} color={iconColor} />
      </IconButton>
    </Tooltip>
  );
};

HelpTooltip.propTypes = {
  title: PropTypes.node.isRequired,
  placement: PropTypes.oneOf([
    "top",
    "bottom",
    "left",
    "right",
    "top-start",
    "top-end",
    "bottom-start",
    "bottom-end",
  ]),
  size: PropTypes.oneOf(["small", "medium"]),
  color: PropTypes.oneOf(["action", "primary", "info", "warning", "error"]),
  interactive: PropTypes.bool,
  maxWidth: PropTypes.number,
  icon: PropTypes.oneOfType([
    PropTypes.oneOf(["help", "info", "warning", "error"]),
    PropTypes.elementType,
  ]),
  sx: PropTypes.object,
};

export default HelpTooltip;
